import { useState, useMemo, useEffect, useRef } from "react";
import { getCountries, getCountryCallingCode } from "libphonenumber-js";
import { TextField } from "./inputFiled";

export const CountryModel = ({ onSelect, onClose }) => {
  const [query, setQuery] = useState("");
  const invalidFlagsRef = useRef(new Set());

  const allCountries = useMemo(() => {
    return getCountries().map((code) => ({
      code: code.toLowerCase(),
      name: new Intl.DisplayNames(["en"], { type: "region" }).of(code),
      dialCode: getCountryCallingCode(code),
      flag: `https://flagcdn.com/w40/${code.toLowerCase()}.png`,
    }));
  }, []);

  const filtered = allCountries.filter((c) =>
    c.name.toLowerCase().includes(query.toLowerCase()) &&
    !invalidFlagsRef.current.has(c.code)
  );

  // Close on ESC
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-[22000] bg-black bg-opacity-50 flex items-center justify-center"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
    >
      <div
        className="w-full max-w-[520px] p-6 sm:p-8 md:p-10 bg-white rounded-2xl shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >

        <div className="space-y-3 mb-6">
          <div className="flex items-center justify-between">
            <div className="text-xl text-[#000000] font-medium">Select Your Country</div>
            <button
              type="button"
              aria-label="Close"
              onClick={onClose}
              className="p-2 rounded-full hover:bg-gray-100"
            >
              <img src="/input-logos/close.svg" alt="close" className="w-5 h-5" />
            </button>
          </div>
          <p className="text-[#475467] font-medium">Help Us Personalise Your Experience.</p>
        </div>
        {/* Header */}
        {/* <div className="flex justify-between items-center mb-2">
          <h2 className="text-xl font-semibold">Select Your Country</h2>

          <button onClick={onClose}>
            <img src="/input-logos/close.svg" className="w-6 h-6" />
          </button>
        </div>

        <p className="text-gray-500 text-sm mb-6">
          Help Us Personalise Your Experience.
        </p> */}

        {/* Search using EXACT same TextField as before */}
        <TextField
          placeholder="Search"
          startIcon="/input-logos/search.svg"
          rightIcon={
            
              <button type="button" onClick={() => setQuery("")}>
                <img
                  src='/input-logos/close.svg'
                  alt="close"
                  className="w-4 h-4 mt-1"
                />          
                    </button>
            
          }
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />

        {/* Country list same design */}
        <div className="space-y-3 max-h-80 overflow-y-auto mt-4  [&::-webkit-scrollbar]:w-1
            [&::-webkit-scrollbar-thumb]:bg-gray-400 
            [&::-webkit-scrollbar-thumb]:rounded-full 
            [&::-webkit-scrollbar-track]:bg-gray-100">
          {filtered.map((c) => (
            <button
              key={c.code}
              type="button"
              onClick={() => onSelect(c)}
              className="w-full flex items-center justify-between gap-3 rounded-xl border border-gray-300 px-4 py-3 hover:border-violet-500 hover:bg-violet-50 transition"
              style={{
                display: invalidFlagsRef.current.has(c.code) ? "none" : "flex"
              }}
            >
              <div className="flex items-center gap-3">
                <img 
                  src={c.flag} 
                  alt={c.name} 
                  className="w-6 h-4 rounded-sm" 
                  onError={(e) => {
                    invalidFlagsRef.current.add(c.code);
                    e.currentTarget.closest("button").style.display = "none";
                  }}
                />
                <span>{c.name}</span>
              </div>

              <span className="text-gray-600 font-semibold">+{c.dialCode}</span>
            </button>
          ))}

          {filtered.length === 0 && (
            <p className="text-center text-sm text-gray-500">No matches found</p>
          )}
        </div>
      </div>
    </div>
  );
};


// export const CountrySelector = () => {
//   const [query, setQuery] = useState("");

//   const allCountries = useMemo(() => {
//     return getCountries().map((code) => ({
//       code: code.toLowerCase(),
//       name: new Intl.DisplayNames(['en'], { type: 'region' }).of(code),
//       dialCode: getCountryCallingCode(code),
//       flag: `https://flagcdn.com/w40/${code.toLowerCase()}.png`,
//     }));
//   }, []);

//   const filtered = allCountries.filter((c) =>
//     c.name.toLowerCase().includes(query.toLowerCase())
//   );

//   const handleCountryClick = (country) => {
//     localStorage.setItem("selectedCountry", country.code);
//     localStorage.setItem("selectedDialCode", `+${country.dialCode}`);
//     window.location.href = "/sign-up";
//   };

//   return (
//     <AuthLayout title="Select Your Country" subtitle="Help Us Personalise Your Experience.">
//       <div className="space-y-5">
//         <TextField
//           placeholder="Search"
//           startIcon="/input-logos/search.svg"
//           rightIcon={
//             query && (
//               <button type="button" onClick={() => setQuery("")}>
//                 <img src="/input-logos/close.svg" className="w-4 h-4" alt="X" />
//               </button>
//             )
//           }
//           value={query}
//           onChange={(e) => setQuery(e.target.value)}
//         />

//         <div className="space-y-3 max-h-80 overflow-y-auto">
//           {filtered.map((c) => (
//             <button
//               key={c.code}
//               type="button"
//               onClick={() => handleCountryClick(c)}
//               className="w-full flex items-center justify-between gap-3 rounded-xl border border-gray-300 px-4 py-3 hover:border-violet-500 hover:bg-violet-50 transition"
//             >
//               <div className="flex items-center gap-3">
//                 <img src={c.flag} alt={c.name} className="w-6 h-4 rounded-sm" />
//                 <span>{c.name}</span>
//               </div>

//               <span className="text-gray-600 font-semibold">+{c.dialCode}</span>
//             </button>
//           ))}

//           {filtered.length === 0 && (
//             <p className="text-center text-sm text-gray-500">No matches found</p>
//           )}
//         </div>
//       </div>
//     </AuthLayout>
//   );
// };